// Mock Schedule Data - İNSANET
// Program defteri verileri — kullanıcıya özel (user_id bazlı izolasyon)

export const eventCategories = [
    { key: 'tapu', label: 'Tapu', color: 'bg-info', textColor: 'text-info-dark' },
    { key: 'musteri', label: 'Müşteri', color: 'bg-success', textColor: 'text-success-dark' },
    { key: 'toplanti', label: 'Toplantı', color: 'bg-warning', textColor: 'text-warning-dark' },
    { key: 'teslimat', label: 'Teslimat', color: 'bg-secondary', textColor: 'text-secondary-dark' },
    { key: 'diger', label: 'Diğer', color: 'bg-tertiary', textColor: 'text-tertiary-dark' },
];

// Her etkinlik bir kullanıcıya (userId) aittir — Program Defteri kişiseldir.
// Aynı inşaat projesine erişen farklı kullanıcılar birbirinin etkinliklerini görmez.
export const mockEvents = [
    // --- Admin kullanıcısı (userId: '1') etkinlikleri ---
    {
        id: 'evt-1',
        userId: '1',
        constructionId: 'ins-1',
        title: 'A-3 Dairesi Tapu Devri',
        date: '2026-03-10',
        time: '10:00',
        category: 'tapu',
        description: 'Ahmet Yılmaz ile tapu dairesinde buluşma',
        createdBy: 'Müteahhit Admin',
    },
    {
        id: 'evt-2',
        userId: '1',
        constructionId: 'ins-1',
        title: 'B-4 Müşteri Ziyareti',
        date: '2026-03-11',
        time: '14:00',
        category: 'musteri',
        description: 'Ayşe Öztürk daireyi görmek istiyor',
        createdBy: 'Müteahhit Admin',
    },
    {
        id: 'evt-3',
        userId: '1',
        constructionId: 'ins-1',
        title: 'Haftalık Ekip Toplantısı',
        date: '2026-03-12',
        time: '09:00',
        category: 'toplanti',
        description: 'Tüm ekip ile haftalık değerlendirme',
        createdBy: 'Müteahhit Admin',
    },
    {
        id: 'evt-4',
        userId: '1',
        constructionId: 'ins-1',
        title: 'Banka Görüşmesi',
        date: '2026-03-14',
        time: '11:00',
        category: 'diger',
        description: 'Kredi yapılandırma görüşmesi',
        createdBy: 'Müteahhit Admin',
    },
    {
        id: 'evt-5',
        userId: '1',
        constructionId: 'ins-1',
        title: 'C-1 Tapu Devri',
        date: '2026-03-15',
        time: '14:30',
        category: 'tapu',
        description: 'Ali Çelik ile tapu dairesinde buluşma',
        createdBy: 'Müteahhit Admin',
    },
    // --- Şantiye Şefi kullanıcısı (userId: '2') etkinlikleri ---
    {
        id: 'evt-6',
        userId: '2',
        constructionId: 'ins-1',
        title: 'Seramik Teslimatı',
        date: '2026-03-13',
        time: '08:00',
        category: 'teslimat',
        description: '200 m² seramik gelecek, konteynere yerleştirme',
        createdBy: 'Şantiye Şefi',
    },
    {
        id: 'evt-7',
        userId: '2',
        constructionId: 'ins-1',
        title: 'Mimar Toplantısı',
        date: '2026-03-09',
        time: '16:00',
        category: 'toplanti',
        description: 'Yeni blok planları değerlendirmesi',
        createdBy: 'Şantiye Şefi',
    },
    {
        id: 'evt-8',
        userId: '2',
        constructionId: 'ins-1',
        title: 'Demir Siparişi Takibi',
        date: '2026-03-16',
        time: '10:00',
        category: 'teslimat',
        description: '15 ton Q335 demir, tedarikçiyle buluşma',
        createdBy: 'Şantiye Şefi',
    },
];

// --- Helper Fonksiyonlar ---

/**
 * Kullanıcıya ve inşaata göre etkinlikleri döndürür.
 * Program Defteri kişiseldir — her kullanıcı sadece kendi eklediği etkinlikleri görür.
 *
 * @param {string|null} constructionId - Aktif inşaat ID'si (null ise tüm inşaatlar)
 * @param {string|null} userId - Giriş yapmış kullanıcının ID'si
 */
export const getEventsByUser = (constructionId, userId) => {
    return mockEvents.filter(e => {
        const matchesUser = !userId || e.userId === userId;
        const matchesConstruction = !constructionId || e.constructionId === constructionId || !e.constructionId;
        return matchesUser && matchesConstruction;
    });
};

// Geriye dönük uyumluluk için (eski kullanım varsa)
export const getEventsByConstructionId = (constructionId) => {
    if (!constructionId) return mockEvents;
    return mockEvents.filter(e => e.constructionId === constructionId || !e.constructionId);
};

export const getEventsByDate = (date) => {
    return mockEvents.filter(e => e.date === date);
};

export const getUpcomingEvents = (events = mockEvents, limit = 5) => {
    const today = new Date().toISOString().split('T')[0];
    return [...events]
        .filter(e => e.date >= today)
        .sort((a, b) => a.date.localeCompare(b.date) || a.time.localeCompare(b.time))
        .slice(0, limit);
};

export default mockEvents;
